// The Northern Lights style's aurora (HarborAurora.css draws it behind open menus).
// Each of its two layers is baked once into a small image -- colours and rays combined --
// so an open menu only slides two pictures: live CSS masks of this many shapes drove the
// graphics card hard every time a menu opened. The aurora is soft, so a small canvas
// scaled up looks the same. The images are blob: links on <html> (--hb-nl-a, --hb-nl-b).

// Green, teal and violet, as the aurora shows them.
const COLOURS = ['#3dffa8', '#2fd6e0', '#9b6bff'];
// Colour bands per layer: [width %, height %, centre x %, centre y %, colour, fade stop %].
const BANDS = [
  [[40, 30, 25, 55, 0, 72], [36, 26, 58, 45, 1, 72], [28, 32, 82, 58, 2, 74]],
  [[38, 28, 72, 50, 0, 72], [32, 24, 40, 40, 2, 72], [30, 30, 15, 60, 1, 74]],
];
// Rays per layer: tall soft shapes, each with a wider bulge at one height, over a dim base.
// [width %, height %, centre x %, centre y %, strength, solid to %].
const RAYS = [
    { base: 0.88, rays: [
      [3.2, 55.9, 2.6, 50.8, 0.97, 60],
      [12.3, 10, 2.6, 70.8, 0.87, 35],
      [4.4, 45.6, 9.6, 59.1, 0.98, 60],
      [16.6, 11.8, 11.6, 63.3, 0.88, 35],
      [3, 58.3, 17.5, 59.7, 0.98, 60],
      [11.7, 9.5, 17.5, 35.1, 0.88, 35],
      [2.1, 53.8, 22.8, 53.7, 0.98, 60],
      [5.9, 9.5, 22.4, 71.4, 0.88, 35],
      [5.7, 46.9, 31, 45.9, 1, 60],
      [18, 17.6, 32.4, 74.4, 0.9, 35],
      [3.3, 50.6, 40.7, 40.1, 0.97, 60],
      [9.4, 16.6, 41.5, 34.6, 0.87, 35],
      [3.2, 64.6, 46.4, 48.7, 0.99, 60],
      [6.1, 7.3, 45, 55.4, 0.89, 35],
      [3.2, 62, 53.9, 41.2, 0.99, 60],
      [12, 13.3, 53.7, 51.4, 0.89, 35],
      [4.4, 48.9, 61, 40.1, 0.99, 60],
      [13.7, 10.8, 61.7, 50.6, 0.9, 35],
      [2.9, 56.7, 68.3, 54.5, 1, 60],
      [11.2, 11, 67.4, 41.3, 0.9, 35],
      [2, 51.4, 74.6, 55.1, 1, 60],
      [7.3, 7.3, 74.1, 68.9, 0.9, 35],
      [4, 46.1, 80.2, 53.3, 0.98, 60],
      [8.3, 9.1, 81.9, 55.8, 0.88, 35],
      [4.1, 62.4, 88.8, 46.8, 0.98, 60],
      [9.4, 11.7, 89.3, 73.1, 0.89, 35],
      [4.3, 57.8, 96.7, 48.2, 0.98, 60],
      [10.4, 13.5, 96.2, 62.1, 0.89, 35],
    ] },
    { base: 0.88, rays: [
      [2.6, 64.2, 2, 46.7, 0.97, 60],
      [4.6, 18.9, 1.2, 64.4, 0.88, 35],
      [3.6, 59.7, 7.5, 51.7, 0.99, 60],
      [10.4, 10.3, 7.7, 51.3, 0.89, 35],
      [4.5, 57.2, 14.6, 57.7, 0.97, 60],
      [16.8, 8.2, 14.1, 61.1, 0.87, 35],
      [4.4, 53.9, 22.4, 57.1, 0.99, 60],
      [9.7, 9.3, 21.5, 51.5, 0.9, 35],
      [4.9, 64.8, 31.3, 53.7, 1, 60],
      [8.5, 12.1, 31.3, 35, 0.9, 35],
      [2.1, 59.9, 39.2, 50.3, 0.99, 60],
      [4, 9.1, 39.3, 50.8, 0.89, 35],
      [3.9, 64.9, 45.4, 58.7, 0.99, 60],
      [7.8, 9.7, 44.8, 43.6, 0.89, 35],
      [0.9, 53.6, 51, 41.5, 0.99, 60],
      [3.4, 16.8, 50.9, 51.7, 0.89, 35],
      [2.9, 52, 55.8, 53.8, 0.98, 60],
      [8.5, 18.8, 55.5, 61.4, 0.88, 35],
      [0.7, 59.8, 61, 45.7, 0.97, 60],
      [2.1, 13.1, 60.9, 62.8, 0.88, 35],
      [3.6, 50.1, 65.9, 47.4, 0.99, 60],
      [10.1, 10.1, 66.6, 62.9, 0.89, 35],
      [0.9, 55.1, 70.7, 49.5, 0.97, 60],
      [1.7, 7.8, 70.3, 38.2, 0.88, 35],
      [3.8, 58.8, 76.8, 48.8, 0.98, 60],
      [7.4, 10.1, 77.1, 59.3, 0.88, 35],
      [2.1, 54.1, 82.4, 43.2, 0.97, 60],
      [7.2, 13.6, 82.6, 44, 0.87, 35],
      [0.6, 53.9, 85.1, 52.9, 0.99, 60],
      [2.2, 17.5, 85.4, 59.1, 0.89, 35],
      [2.8, 49.7, 89.1, 42.6, 0.99, 60],
      [9.4, 8.4, 89.8, 38.7, 0.89, 35],
      [3.4, 50.4, 94.5, 56.6, 1, 60],
      [12.6, 10.5, 94, 50.9, 0.9, 35],
    ] },
];
const W = 480, H = 300;

function ellipse(ctx, rx, ry, cx, cy, stops) {
  ctx.save();
  ctx.translate(cx / 100 * W, cy / 100 * H);
  ctx.scale(rx / 100 * W, ry / 100 * H);
  const g = ctx.createRadialGradient(0, 0, 0, 0, 0, 1);
  stops.forEach(([at, c]) => g.addColorStop(at, c));
  ctx.fillStyle = g;
  ctx.fillRect(-50, -50, 100, 100);
  ctx.restore();
}

const rgba = (hex, a) => `rgba(${parseInt(hex.slice(1, 3), 16)},${parseInt(hex.slice(3, 5), 16)},${parseInt(hex.slice(5, 7), 16)},${a})`;

function bake(layer) {
  const c = document.createElement('canvas');
  c.width = W; c.height = H;
  const ctx = c.getContext('2d');
  [...BANDS[layer]].reverse().forEach(([rx, ry, cx, cy, ci, stop]) =>
    ellipse(ctx, rx, ry, cx, cy, [[0, COLOURS[ci]], [stop / 100, rgba(COLOURS[ci], 0)], [1, rgba(COLOURS[ci], 0)]]));
  const m = document.createElement('canvas');
  m.width = W; m.height = H;
  const mx = m.getContext('2d');
  mx.fillStyle = `rgba(0,0,0,${RAYS[layer].base})`;
  mx.fillRect(0, 0, W, H);
  RAYS[layer].rays.forEach(([rx, ry, cx, cy, a, stop]) =>
    ellipse(mx, rx, ry, cx, cy, [[0, `rgba(0,0,0,${a})`], [stop / 100, `rgba(0,0,0,${a})`], [1, 'rgba(0,0,0,0)']]));
  ctx.globalCompositeOperation = 'destination-in';
  ctx.drawImage(m, 0, 0);
  return c;
}

// Once per page load, the first time the Northern Lights style shows.
let baked = false;
export function bakeAurora() {
  if (baked) return;
  baked = true;
  const root = document.documentElement.style;
  [0, 1].forEach((layer) => bake(layer).toBlob((blob) => {
    if (blob) root.setProperty(layer ? '--hb-nl-b' : '--hb-nl-a', `url(${URL.createObjectURL(blob)})`);
  }));
}
